import { render } from "./HeroiconsOutlineChevronDoubleLeft.vue?vue&type=template&id=7713297f"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleLeft.vue"]])

export default __exports__